
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["pause_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M341.318 142.243c47.15 0 85.364 38.167 85.364 85.318v568.832a85.318 85.318 0 01-170.682 0V227.607c0-47.15 38.167-85.318 85.318-85.318zm341.364 0c47.104 0 85.318 38.167 85.318 85.318v568.832a85.318 85.318 0 01-170.682 0V227.607c0-47.15 38.214-85.318 85.364-85.318z","fill":"#333"}})])
          )
        }
      }
    